import "core-js/modules/es.array.push.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import $cookies from 'vue-cookies';
import jwt from 'jsonwebtoken';
export default {
  name: 'AdminDashboard',
  data() {
    return {
      hydrated: false
    };
  },
  computed: {
    formControl() {
      return this.$route.name == 'login';
    }
  },
  async mounted() {
    this.hydrated = true;
    const logincookie = $cookies.get('accessToken');
    const token = jwt.decode(logincookie);
    if (logincookie && token['custom:role'] != 'ADMIN') {
      await this.logout();
      this.$router.push('/login');
    }
  },
  methods: {
    async logout() {
      try {
        const refreshToken = localStorage.getItem('refreshToken');
        if (refreshToken) {
          const tokenUrl = `https://${process.env.VUE_APP_COGNITO_USER_POOL_DOMAIN}/oauth2/revoke`;
          const body = new URLSearchParams();
          body.append('client_id', process.env.VUE_APP_COGNITO_CLIENT_ID);
          body.append('token', refreshToken);
          await fetch(tokenUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: body.toString()
          });
        }
        $cookies.keys().forEach(cookie => $cookies.remove(cookie));
        localStorage.clear();
        this.store.dispatch('auth/resetState');
        const logoutUrl = `https://${process.env.VUE_APP_COGNITO_USER_POOL_DOMAIN}/logout?client_id=${process.env.VUE_APP_COGNITO_CLIENT_ID}&logout_uri=${window.location.origin}/login`;
        window.location = logoutUrl;
      } catch (error) {
        console.error('Error:', error);
      }
    }
  }
};